var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 6 : 1 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addHandServer.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("openServer")))]
              )
            ],
            1
          ),
          _c("el-col", { attrs: { span: _vm.isMobile ? 6 : 4 } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  width: "100%"
                }
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { flex: "1", width: "0" },
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("isOpenServerSuccess")
                    },
                    model: {
                      value: _vm.paramsData.status,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "status", $$v)
                      },
                      expression: "paramsData.status"
                    }
                  },
                  _vm._l(_vm.serverLaunch, function(item) {
                    return _c("el-option", {
                      key: item.label,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _c(
                  "el-tooltip",
                  {
                    staticStyle: { "margin-left": "10px", "flex-shrink": "0" },
                    attrs: { effect: "dark", placement: "top" }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "content" },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("serverLaunchStatusTip"))
                      },
                      slot: "content"
                    }),
                    _c("i", { staticClass: "el-icon-question" })
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: _vm.$t("idLabel"), width: "60" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_name", label: _vm.$t("gameIdentifier") }
          }),
          _c("el-table-column", {
            attrs: { prop: "is_delay", label: _vm.$t("isDelayed") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      row.is_delay == "1"
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("yes")))])
                        : _vm._e(),
                      row.is_delay == "0"
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("no")))])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "delay_time", label: _vm.$t("delayTime") }
          }),
          _c("el-table-column", {
            attrs: { prop: "op_time", label: _vm.$t("operationTime") }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: _vm.$t("isOpenSuccess") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      row.status == "1"
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("yes")))])
                        : _vm._e(),
                      row.status == "2"
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("no")))])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "area_id", label: _vm.$t("regionLabel") }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pre_max_serverid",
              label: _vm.$t("prevMaxServerId")
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "open_serverid",
              label: _vm.$t("operatedOpenServerId")
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: _vm.$t("adminLabel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reason", label: _vm.$t("reason") }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "120",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      row.is_delay == "1" && row.status == "0"
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(row.id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("delete")))]
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("addHandServer", {
        ref: "addHandServer",
        on: {
          update: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("richTextDetails", { ref: "richTextDetails" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }